import { useContext } from 'react';
import { TheBoatDbApiContext } from './TheBoatDbApiProvider';

export function useTheBoatDbApi() {
  const contextValue = useContext(TheBoatDbApiContext);

  if (!contextValue) {
    throw new Error(
      'TheBoatDB API client is not configured. Pass `theBoatDbApiUrl` to ApiServicesProvider in this app.',
    );
  }

  return contextValue;
}
